import { isArticleSection, sectionSlots } from "./sections";
import type { NewsletterSection, SectionArticle } from "./segment-types";
import type { PreviewSection } from "./newsletter-html";

/**
 * Fill a newsletter's open article slots from a pool for one category.
 *
 * Pure, so the editor's preview and the send engine (which builds one email
 * per category on the Worker) give the same answer. Sections are walked in
 * order and the pool handed out so the same piece never appears twice in an
 * issue; pinned links always come first.
 */
export function resolveSections(
  sections: NewsletterSection[],
  pool: SectionArticle[],
): PreviewSection[] {
  const norm = (u: string) => u.replace(/\/+$/, "");
  const taken = new Set<string>();
  return sections.map((s) => {
    const base: PreviewSection = {
      id: s.id, type: s.type, heading: s.heading, layout: s.layout,
      text: s.text, url: s.url, image: s.image, cta_label: s.cta_label,
    };
    if (!isArticleSection(s.type)) return base;
    const pinned = s.articles ?? [];
    pinned.forEach((a) => taken.add(norm(a.url)));
    const need = Math.max(0, sectionSlots(s) - pinned.length);
    const filled = pool.filter((a) => !taken.has(norm(a.url))).slice(0, need);
    filled.forEach((a) => taken.add(norm(a.url)));
    return {
      ...base,
      articles: [...pinned, ...filled].map((a) => ({
        title: a.title, url: a.url, excerpt: a.excerpt, image: a.image,
        layout: a.layout, category: a.category, read_minutes: a.read_minutes,
      })),
    };
  });
}
